





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CodeField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: string;

  @Prop({ default: false })
  public isDisabled!: string;

  // Methods

  public onInput(value) {
    this.$emit("input", value);
  }
}
